import axiosInstance from "../lib/axiosInstance";
const baseUrl = process.env.REACT_APP_API_URL;


const adminModel = class {

    async bookingDetails(id) {
        const data = await axiosInstance.get(baseUrl+"/admin/bookings/experience/"+id);
        return data;
    }

    async bookingDelete(id) {
        const data = await axiosInstance.delete(baseUrl+"/admin/bookings/"+id);
        return data;
    }

    async profileUpdate(formData) {
        const data = await axiosInstance.put(baseUrl+"/admin/profile", formData , {
            headers : {
                "Content-Type" : 'multipart/form-data'
            }
        });
        return data;
    }

    async termAndCondition(terms) {
        const data = await axiosInstance.put(baseUrl+"/admin/terms-and-conditions", terms);
        return data;
    }

    async getProfile() {
        const data = await axiosInstance.get(baseUrl+"/admin/profile");
        return data;
    }

    async userDelete(id) {
        const data = await axiosInstance.delete(baseUrl+"/admin/user/"+id);
        return data;
    }

    async getExperienceCategory(query=''){
        return (await axiosInstance.get(baseUrl+'/admin/category?id='+query)).data
    }
    

    async updateExperienceCategory(id, data){
        return (await axiosInstance.put(baseUrl+'/admin/category/'+id, data)).data
    }

    async deleteCategory(id){
        return (await axiosInstance.delete(baseUrl+'/admin/category/'+id)).data
    }

    async getTermsAndConditions(){
        return (await axiosInstance.get(baseUrl+'/admin/terms-and-conditions')).data
    }

    async createExperienceCategory(data){
        return (await axiosInstance.post(baseUrl+'/admin/category', data)).data
    }

    async getAllSubAdmins(id = ''){
        return (await axiosInstance.get(baseUrl+'/admin/subadmin?id=' + id)).data
    }

    async deleteSubAdmin(id = ''){
        return (await axiosInstance.delete(baseUrl+'/admin/subadmin/' + id)).data
    }
    
    async createSubAdmin(data){
        return (await axiosInstance.post(baseUrl+'/admin/create-subadmin'  , data )).data
    }

    async updateSubAdmin(id, data){
        return (await axiosInstance.put(baseUrl+'/admin/subadmin/' + id, data)).data
    }

    async createExperienceOption(data){
        return (await axiosInstance.post(baseUrl+'/admin/add-options', data)).data
    }

    async getAllSubCategories(id){
        return (await axiosInstance.get(baseUrl+`/admin/all-options/${id}` )).data
    }

    async deleteOption(data){
        return (await axiosInstance.put(baseUrl+'/admin/delete-option' , data )).data
    }

    
}

export default new adminModel();
